import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MensajeToast',
  setup(__props, { expose: __expose }) {

/**
 * Aviso efímero no bloqueante.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const visible = ref(false)
const mensaje = ref('')
const tipo = ref<'exito' | 'error'>('exito')

function showToast(msg: string, t: 'exito' | 'error' = 'exito') {
  mensaje.value = msg
  tipo.value = t
  visible.value = true
  setTimeout(() => (visible.value = false), 3000)
}

__expose({ showToast })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["toast", tipo.value])
          }, _toDisplayString(mensaje.value), 3))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})